import { uiStore } from 'shared/store/uiStore'
import { ChatbotInstructionType } from 'entities/Chatbot'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

export const handleDuplicate = (type: ChatbotInstructionType | null, id: number) => {
  const createPath =
    type === ChatbotInstructionType.BookAppointment
      ? `/${ChatbotPath.newBookAppointment}`
      : `/${ChatbotRoutes.root}/${ChatbotRoutes.new}`

  uiStore.changeRoute({
    path: createPath,
    options: {
      state: {
        duplicateId: id,
      },
    },
  })
}
